// @ts-nocheck
import * as React from "react";
import { Sidebar, Topbar, NotifyFeed, useCurrentUser } from "./common";

// 관리자(시스템·플랫폼·권역·유관기관) 데스크톱 알림함.
//
// 토프바 알림 드롭다운의 "전체 보기" 대상. 과거엔 관리자도 소비자 모바일 화면
// (/m/notify=notify-center)으로 보내, 그 화면 가드(guardian/citizen 전용)에 막혀
// default_path(플랫폼/권역 대시보드)로 튕기는 버그가 있었다. 이 전용 화면을 두어 해결.
//
// 데스크톱 chrome(Sidebar+Topbar)에 공용 NotifyFeed를 얹는다 — 목록/필터/읽음/삭제
// 로직은 NotifyFeed가 단일 소스. 데이터는 /api/v1/notifications 신원 스코프(역할별
// admin 큐: system/platform=전체 admin, region_admin/ops=자기 권역 admin).
export function AdminNotifications() {
  const { user } = useCurrentUser();
  // Sidebar 내비 세트는 역할군에 맞춰 — platform/region/agency.
  const navRole =
    user?.role === "system_admin" ? "platform"
    : user?.role === "agency" ? "agency"
    : "region";

  return (
    <div className="app" style={{height:'100vh'}}>
      <div className="shell">
        <Sidebar role={navRole} active="notifications"/>
        <div style={{display:'flex', flexDirection:'column', overflow:'hidden'}}>
          <Topbar title="알림함" sub="내 역할로 수신된 알림을 모아 봅니다"/>
          <div className="main">
            <div style={{marginBottom:18}}>
              <div className="h1">알림함</div>
              <div className="muted" style={{marginTop:4, fontSize:13}}>읽음 처리·필터·삭제를 관리할 수 있습니다.</div>
            </div>
            {/* NotifyFeed의 목록이 flex:1·overflow:auto라 높이 가진 flex 컬럼 카드에 담는다. */}
            <div className="card" style={{overflow:'hidden', display:'flex', flexDirection:'column', height:'calc(100vh - 220px)'}}>
              <NotifyFeed/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
